export const getUserAgent = (isOriginFormat = false) => {
    const { hideAdminControls, emulate } = Object.fromEntries(new URLSearchParams(location.search).entries());
    let ua = window.navigator.userAgent;

    if (hideAdminControls === '1') {
        if (emulate === 'mobile') {
            ua = 'Mozilla/5.0 (iPhone; CPU iPhone OS 13_2_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.3 Mobile/15E148 Safari/604.1';
        }

        if (emulate === 'tablet') {
            ua = 'Mozilla/5.0 (iPad; CPU OS 11_0 like Mac OS X) AppleWebKit/604.1.34 (KHTML, like Gecko) Version/11.0 Mobile/15A5341f Safari/604.1';
        }
    }

    return isOriginFormat ? ua : ua.toLowerCase();
};

export const isCrawlerBot = () =>
    /bot|google|baidu|bing|msn|duckduckgo|teoma|slurp|yandex/i.test(getUserAgent())
    || /Chrome-Lighthouse|Page Speed Insights/i.test(getUserAgent())
    || window.isCrawler;

export const isVisualCustomizationMode = () => {
    const searchParams = new URLSearchParams(location.search);
    const emulate = searchParams.get('emulate');

    return window.self !== window.top // iframe
        && searchParams.get('hideAdminControls') === '1'
        && (emulate === 'mobile' || emulate === 'tablet');
};
